export default __webpack_public_path__ + "static/media/newLink.3883114f.svg";